import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ModalTypes } from '../../../helpers/enums';
import { selectRequestConversionStatusLoading, selectRequestConversionStatusSuccess } from '../../../store/recordings';
import CustomModal from '../../CustomModal';

const customStyles = {
  content: {
    top: '40%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '19px 16px',
    textAlign: 'center',
    transform: 'translate(-50%, -50%)',
    width: '375px',
  },
  overlay: {
    backgroundColor: 'rgb(0,0,0,0.5)',
    zIndex: '5',
  },
};

const DownloadRequestModal = ({ timeEstimateText, setDownloadRequestedModal }) => {
  const isLoading = useSelector(selectRequestConversionStatusLoading);
  const isSuccess = useSelector(selectRequestConversionStatusSuccess);
  const [modalOptions, setModalOptions] = useState({
    confirmButtonText: null,
    confirmationText: (
      <div>
        <div className="spinner relative-spinner" />
        <span className="loadingText">Loading...</span>
      </div>
    ),
    modalTitle: 'Requesting Export',
  });

  useEffect(() => {
    if (!isLoading && isSuccess) {
      setModalOptions({
        confirmButtonText: 'OK',
        confirmationText: (
          <div>
            It will take approximately {timeEstimateText} to complete. You&apos;ll receive an email as soon as it is
            available.
          </div>
        ),
        modalTitle: 'Export in progress',
      });
    } else if (!isLoading && !isSuccess) {
      setModalOptions({
        confirmButtonText: 'OK',
        confirmationText: (
          <div>
            Unfortunately there was an issue generating your file, please try again. If it continues to fail please
            contact support for further assistance.
          </div>
        ),
        modalTitle: 'Export error',
      });
    }
  }, [isLoading, isSuccess, timeEstimateText]);

  return (
    <CustomModal
      includeButtons
      isOpen
      handleOnClose={() => setDownloadRequestedModal(null)}
      handleOnConfirm={() => setDownloadRequestedModal(null)}
      confirmButtonText={modalOptions.confirmButtonText}
      confirmationText={modalOptions.confirmationText}
      modalTitle={modalOptions.modalTitle}
      type={ModalTypes.CONFIRMATION}
      customStyles={customStyles}
    />
  );
};

DownloadRequestModal.defaultProps = {
  timeEstimateText: undefined,
};

DownloadRequestModal.propTypes = {
  timeEstimateText: PropTypes.string,
  setDownloadRequestedModal: PropTypes.func.isRequired,
};

export default DownloadRequestModal;
